module.exports = __webpack_public_path__ + "img/taiyos4.c9ed06a1.gif";